module.exports = __webpack_public_path__ + "static/media/6.14e471d2.svg";